import { api } from '@services';

import Task, {
  ITaskApiRawQuery,
  ITaskRawQuery,
  TaskPriorityOptions,
  TaskStatusOptions,
} from '@models/Task.model';

interface ICreateTask {
  title: string;
  description: string;
  status?: TaskStatusOptions | null;
  priority?: TaskPriorityOptions | null;
  dueDate?: Date | null;
  assigneeId?: string | null;
}

const createTask = async (data: ICreateTask): Promise<ITaskRawQuery> => {
  const { data: task } = await api.post<ITaskApiRawQuery>('/tasks', data);

  return Task.fromApiRawQueryModel(task);
};

export { createTask };
